<template>
  <div class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-b-md ts-p-3">
    <label>{{ $t('saleContract.previewOption') }}</label>
    <div class="ts-flex ts-space-x-3">
      <ts-checkbox v-model="model.exclude_price">{{
        $t('saleContract.excludePrice')
      }}</ts-checkbox>
      <div class="ts-border ts-border-blue-400 ts-rounded ts-p-1">
        <div>
          <a-radio-group name="radioGroup" v-model="model.currency">
            <a-radio value="USD"> USD </a-radio>
            <a-radio value="KHR"> KHR </a-radio>
            <a-radio value="THB"> THB </a-radio>
          </a-radio-group>
        </div>
        <small>{{ $t('saleContract.currency') }}</small>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'previewOption',
  props: ['value', 'validate'],
  data () {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created () {
    this.model = this.value
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
